import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PendingTasksCard = ({ tasks = [], onTaskAction }) => {
  const getPriorityColor = (priority) => {
    const colorMap = {
      high: 'text-error',
      medium: 'text-warning',
      low: 'text-success'
    };
    return colorMap?.[priority] || 'text-text-secondary';
  };

  const getPriorityBadge = (priority) => {
    const badgeMap = {
      high: 'bg-error/10 text-error',
      medium: 'bg-warning/10 text-warning',
      low: 'bg-success/10 text-success'
    };
    return badgeMap?.[priority] || 'bg-muted text-text-secondary';
  };

  if (tasks?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <Icon name="CheckCircle" size={20} className="text-success" />
          <h3 className="text-lg font-semibold text-text-primary">Pending Tasks</h3>
        </div>
        <div className="text-center py-8">
          <Icon name="CheckCircle2" size={48} className="text-success mx-auto mb-4 opacity-50" />
          <p className="text-text-secondary">All caught up! No pending tasks.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <Icon name="AlertCircle" size={20} className="text-warning" />
          <h3 className="text-lg font-semibold text-text-primary">Pending Tasks</h3>
        </div>
        <span className="text-xs px-2 py-1 rounded-full bg-warning/10 text-warning font-medium">
          {tasks?.length} {tasks?.length === 1 ? 'Task' : 'Tasks'}
        </span>
      </div>
      <div className="space-y-3">
        {tasks?.map((task) => (
          <div
            key={task?.id}
            className="border border-border rounded-lg p-4 hover:bg-muted transition-colors duration-150"
          >
            <div className="flex items-start justify-between gap-4 mb-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="text-sm font-medium text-text-primary">{task?.title}</h4>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${getPriorityBadge(task?.priority)}`}>
                    {task?.priority?.toUpperCase()}
                  </span>
                </div>
                <p className="text-xs text-text-secondary">{task?.description}</p>
              </div>
              <Icon
                name={task?.icon || 'AlertCircle'}
                size={16}
                className={getPriorityColor(task?.priority)}
              />
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onTaskAction && onTaskAction(task)}
              iconName="ArrowRight"
              iconPosition="right"
              iconSize={12}
            >
              {task?.actionLabel || 'Take Action'}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PendingTasksCard;